export const setup = appId => {
  if (window.UserLeap) return;
  window.UserLeap = function () {
    // eslint-disable-next-line
    U._queue.push(arguments);
  };
  const U = window.UserLeap;
  U.appId = appId;
  U._queue = [];
};

/**
 * @description Injects UserLeap script in the DOM
 * @see https://docs.sprig.com/docs/web-javascript
 * @see https://app.sprig.com/connect
 * @param {boolean} isProd
 */
export const load = (appId, onLoad, onError) => {
  const l = document;
  const e = 'https://cdn.userleap.com/shim.js';
  let a = appId;

  a = l.createElement('script');
  if (onLoad) {
    a.onload = a.onreadystatechange = onLoad;
    a.onerror = onError || onLoad;
    a.onabort = onError || onLoad;
  }
  a.async = 1;
  a.src = e + '?id=' + appId;
  const p = l.getElementsByTagName('script')[0];
  p.parentNode.insertBefore(a, p);
};
